import { isObject } from '@/types/typeGuards';

export const getJson = (res: Response): Promise<unknown> => res.json();
export const extractDataFromJson = (res: Response) =>
    getJson(res).then((j) => (isObject(j) && 'data' in j ? j.data : j));
export const extractMessageFromJson = (res: Response) =>
    getJson(res).then((j) => (isObject(j) && 'message' in j ? j.message : j));
export const extractErrorFromJson = (res: Response) =>
    getJson(res).then((j) => (isObject(j) && 'error' in j ? j.error : j));
export const getJsonFromBadResponse = (res: Response) =>
    !res.ok ? getJson(res) : Promise.resolve({});
export const isBadResponse = (res: Response) => !res.ok;
